/* Stylesheet */

.chip_item {
  display: flex;
  --padding-start: 21px;
  --min-height: 42px;
  min-width: 120px;
  --color: var(--ion-color-text-secondary);
  --background: var(--ion-gradient-dark-transparent);
  --background-hover: #a3b6d3;
  border-radius: 42px;
  box-shadow: var(--ion-box-shadow);
  font-size: 0.875rem;

  .value {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .icon {
    height: 14px;
    width: 14px;
    color: #ffffff;
  }
}

/* Media Queries */
@media screen and (min-width: 1600px) {
  .chip_item {
    --min-height: 44px;
    font-size: 1rem;
  }
}
